module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-create-entity-button"
  }, [_c('ModalReveal', {
    key: _vm.key,
    ref: _vm.componentId,
    on: {
      "input": _vm.closeInput
    }
  }, [(_vm.item && !_vm.item.component) ? _c('button', {
    staticClass: "button success",
    attrs: {
      "slot": "trigger"
    },
    slot: "trigger"
  }, [_vm._v("Edit")]) : _c('a', {
    staticClass: "fa-stack fa-lg",
    attrs: {
      "slot": "trigger"
    },
    slot: "trigger"
  }, [_c('i', {
    staticClass: "fa fa-circle fa-stack-2x"
  }), _c('i', {
    staticClass: "fa fa-plus fa-stack-1x fa-inverse"
  })]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('label', [_vm._v("Token")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.body.token),
      expression: "body.token"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.body.token)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.body, "token", $event.target.value)
      }
    }
  }), _c('label', [_vm._v("Destination")]), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.body.destination_type),
      expression: "body.destination_type"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.body, "destination_type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function () { return _vm.body.destination_id = null; }]
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("Select an option")]), _vm._l((_vm.destinations), function(destination, key) {
    return _c('option', {
      domProps: {
        "value": key
      }
    }, [_vm._v(_vm._s(destination))])
  })], 2), (_vm.body.destination_type === 'App\\Models\\Plan') ? _c('selectize-plan', {
    attrs: {
      "value-field": true
    },
    model: {
      value: (_vm.body.destination_id),
      callback: function($$v) {
        _vm.$set(_vm.body, "destination_id", $$v)
      },
      expression: "body.destination_id"
    }
  }) : _vm._e(), (_vm.body.destination_type === 'App\\Models\\CommonCost') ? _c('selectize-common-cost', {
    attrs: {
      "value-field": true
    },
    model: {
      value: (_vm.body.destination_id),
      callback: function($$v) {
        _vm.$set(_vm.body, "destination_id", $$v)
      },
      expression: "body.destination_id"
    }
  }) : _vm._e(), (_vm.body.destination_type === 'App\\Models\\Federation') ? _c('selectize-federation', {
    attrs: {
      "value-field": true
    },
    model: {
      value: (_vm.body.destination_id),
      callback: function($$v) {
        _vm.$set(_vm.body, "destination_id", $$v)
      },
      expression: "body.destination_id"
    }
  }) : _vm._e()], 1), _c('div', {
    staticClass: "column"
  }, [_c('label', [_vm._v("Additional"), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.additional_type),
      expression: "additional_type"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.additional_type = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("Select an option")]), _vm._l((_vm.destinations), function(destination, key) {
    return _c('option', {
      domProps: {
        "value": key
      }
    }, [_vm._v(_vm._s(destination))])
  })], 2)]), (_vm.additional_type === 'App\\Models\\Plan') ? _c('selectize-plan', {
    attrs: {
      "value-field": true
    },
    model: {
      value: (_vm.additional_id),
      callback: function($$v) {
        _vm.additional_id = $$v
      },
      expression: "additional_id"
    }
  }) : _vm._e(), (_vm.additional_type === 'App\\Models\\CommonCost') ? _c('selectize-common-cost', {
    attrs: {
      "value-field": true
    },
    model: {
      value: (_vm.additional_id),
      callback: function($$v) {
        _vm.additional_id = $$v
      },
      expression: "additional_id"
    }
  }) : _vm._e(), (_vm.additional_type === 'App\\Models\\Federation') ? _c('selectize-federation', {
    attrs: {
      "value-field": true
    },
    model: {
      value: (_vm.additional_id),
      callback: function($$v) {
        _vm.additional_id = $$v
      },
      expression: "additional_id"
    }
  }) : _vm._e(), _c('button', {
    staticClass: "small button",
    attrs: {
      "disabled": _vm.additional_type === null || _vm.additional_id === null
    },
    on: {
      "click": _vm.addAdditional
    }
  }, [_vm._v("Add")]), _vm._l((_vm.body.additional), function(value, i) {
    return _c('div', {
      staticClass: "prop-item"
    }, [_c('div', {
      staticClass: "input-group"
    }, [_c('span', {
      staticClass: "input-group-label"
    }, [_vm._v(_vm._s(value.class.split('\\')[value.class.split('\\').length - 1]))]), _c('input', {
      staticClass: "input-group-field",
      attrs: {
        "type": "text",
        "disabled": "disabled"
      },
      domProps: {
        "value": value.id
      }
    }), _c('div', {
      staticClass: "input-group-button"
    }, [_c('button', {
      staticClass: "button warning fa fa-times",
      on: {
        "click": function () {
          _vm.body.additional.splice(i, 1)
        }
      }
    })])])])
  })], 2)]), _c('ActionButton', {
    attrs: {
      "slot": "footer",
      "action": _vm.save
    },
    slot: "footer"
  }, [_vm._v("Save")]), _c('button', {
    staticClass: "button alert float-right",
    attrs: {
      "slot": "footer"
    },
    on: {
      "click": function($event) {
        return _vm.$refs[_vm.componentId].close()
      }
    },
    slot: "footer"
  }, [_vm._v("Cancel")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2f4a93b0!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/backoffice/RegistrationTokenReveal.vue
// module id = 2375
// module chunks = 1